import { render, staticRenderFns } from "./SportSimpleTable.vue?vue&type=template&id=1d90d77a&scoped=true&"
import script from "./SportSimpleTable.vue?vue&type=script&lang=js&"
export * from "./SportSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./SportSimpleTable.vue?vue&type=style&index=0&id=1d90d77a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90d77a",
  null
  
)

component.options.__file = "SportSimpleTable.vue"
export default component.exports